import React from 'react';
import { FaPlay, FaDollarSign, FaMusic } from 'react-icons/fa';
import { MdGraphicEq } from 'react-icons/md';
import PieChartComponent from './charts/PieChartComponent';
import LineChartComponent from './charts/LineChartComponent';
import PerformanceCard from './PerformanceCard';
import { calculatePerformanceIncrease } from '../utils/calculationHelpers';

const DashboardDisplay = ({ dashboardData, title }) => {
    if (!dashboardData) {
        return (
            <div className="text-center py-10">
                <p className="text-gray-400">Generate a report to see the dashboard.</p>
            </div>
        );
    }

    const performance = calculatePerformanceIncrease(dashboardData.barchartdata, 'month');

    return (
        <>
            {/* Welcome Banner */}
            <div className="bg-gradient-gold rounded-xl p-6 mb-6">
                <h2 className="text-white text-xl font-semibold mb-2">{title}</h2>
                <p className="text-gray-200 text-sm mb-3">Here's the performance overview.</p>
                <div className="flex items-center text-white text-sm space-x-4">
                    <p><FaMusic className="inline-block mr-1 text-green-400" /> {dashboardData.total_platforms || "0"} platforms</p>
                    <p><FaMusic className="inline-block mr-1 text-green-400" /> {dashboardData.total_songs || "0"} active songs</p>
                </div>
            </div>

            {/* Performance Overview */}
            <div className="mb-8">
                <h2 className="text-lg font-semibold mb-4">
                    <MdGraphicEq className="inline-block mr-2 text-purple-400" /> Performance Overview
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    <PerformanceCard title="Total Songs" value={dashboardData.total_songs || "0"} icon={<FaMusic className="text-gray-400" />} increase={performance.songs_increase || 0} />
                    <PerformanceCard title="Total Views" value={dashboardData.total_views || "0"} icon={<FaPlay className="text-gray-400" />} increase={performance.views_increase || 0} />
                    <PerformanceCard title="Total Royalty" value={`₹${(dashboardData.total_royalty || 0).toFixed(2)}`} icon={<FaDollarSign className="text-gray-400" />} increase={performance.royalty_increase || 0} />
                </div>
            </div>

            {/* Monthly Growth & Platform Distribution */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <PieChartComponent applicationData={dashboardData} />
                <LineChartComponent applicationData={dashboardData} />
            </div>
        </>
    );
};

export default DashboardDisplay;
